import { render, staticRenderFns } from "./ClassNoteSetup.vue?vue&type=template&id=71dd5de2"
import script from "./ClassNoteSetup.vue?vue&type=script&lang=js"
export * from "./ClassNoteSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports